import { render, staticRenderFns } from "./sales-direct-nouhin.vue?vue&type=template&id=5d26cc1a&scoped=true&"
import script from "./sales-direct-nouhin.vue?vue&type=script&lang=js&"
export * from "./sales-direct-nouhin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d26cc1a",
  null
  
)

export default component.exports